import { useQuery } from '@tanstack/react-query';
import { fetchCollectEvidence } from '@/integrations/agreements/client';

export function useCollectEvidence(collectId: string | null) {
  return useQuery({
    queryKey: ['collect-evidence', collectId],
    queryFn: () => fetchCollectEvidence(collectId!),
    enabled: !!collectId,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
}
